import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a323e24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "change-sub-wrapper" }
const _hoisted_2 = { class: "plans-wrapper" }
const _hoisted_3 = { class: "plan-actions" }
const _hoisted_4 = { class: "methods-sum-wrapper" }
const _hoisted_5 = { class: "plan-wrapper" }
const _hoisted_6 = { class: "methods" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "1. Wähle eine Zahlungsmethode", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Wir werden die gewählte Zahlungsmethode für dieses Abonnement autoamtisch belasten.", -1))
const _hoisted_9 = { class: "sum" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "2. Übersicht", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Diese Kosten werden dir heute in Rechnung gestellt. Du erhältst monatlich eine Rechnung mit den Kosten des Abonnements + nutzungsabhängigen Kosten.", -1))
const _hoisted_12 = {
  key: 0,
  class: "promo"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "check_circle", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Zwischensumme (netto)", -1))
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Heute fällig, inkl USt.", -1))
const _hoisted_17 = { class: "actions" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Zurück")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Zahlungspflichtig bestellen")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_plan = _resolveComponent("plan")!
  const _component_step = _resolveComponent("step")!
  const _component_payment_method_selector = _resolveComponent("payment-method-selector")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_tooltip = _resolveComponent("md-tooltip")!
  const _component_billing_change_subscription_sum_loader = _resolveComponent("billing-change-subscription-sum-loader")!
  const _component_stepper = _resolveComponent("stepper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_stepper, { ref: "stepper" }, {
      default: _withCtx(() => [
        _createVNode(_component_step, { index: 0 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.plans, (p) => {
                return (_openBlock(), _createBlock(_component_plan, {
                  key: p,
                  "plan-name": p,
                  row: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_md_button, {
                        variant: "filled",
                        disabled: _ctx.subscription && _ctx.subscription.plan == p,
                        onClick: ($event: any) => (_ctx.selectPlan(p))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString((_ctx.subscription && _ctx.subscription.plan == p) ? 'Im Moment aktiv' : 'Abonnement auswählen'), 1)
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["plan-name"]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_step, { index: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_plan, { "plan-name": _ctx.plan }, null, 8, ["plan-name"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_payment_method_selector, {
                  onSelect: _cache[0] || (_cache[0] = ($event: any) => (_ctx.paymentMethodId = $event))
                }),
                _createVNode(_component_md_input_field, {
                  disabled: !!_ctx.promo,
                  variant: "outlined",
                  label: "Gutscheincode",
                  modelValue: _ctx.promoCode,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.promoCode) = $event)),
                  error: _ctx.promoCodeError,
                  onKeydown: _ctx.promoCodeKeyDown
                }, null, 8, ["disabled", "modelValue", "error", "onKeydown"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                (_ctx.promo)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("em", null, [
                        _createTextVNode(_toDisplayString(_ctx.promoCode) + " angewendet / - ", 1),
                        (_ctx.promo.percent_off)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(_ctx.promo.percent_off) + " % ", 1)
                            ], 64))
                          : (_ctx.promo.amount_off)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString((_ctx.promo.amount_off / 100).toFixed(2).toString().replace('.', ',')) + " € ", 1)
                              ], 64))
                            : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_md_tooltip, {
                        text: "Gutschein entfernen",
                        position: "bottom"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_md_button, {
                            variant: "icon",
                            grey: "",
                            icon: "delete_forever",
                            onClick: _ctx.deletePromoCode
                          }, null, 8, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.invoice)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("table", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberWithDots(_ctx.invoice.subtotal)) + " €", 1),
                          _hoisted_14
                        ]),
                        (_ctx.invoice.discount && _ctx.invoice.discount > 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                              _createElementVNode("td", null, "- " + _toDisplayString(_ctx.numberWithDots(_ctx.invoice.discount)) + " €", 1),
                              _createElementVNode("td", null, "Gutschein " + _toDisplayString(_ctx.promoCode), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", null, _toDisplayString(_ctx.numberWithDots(_ctx.invoice.tax)) + " €", 1),
                          _createElementVNode("td", null, "Umsatzsteuer " + _toDisplayString(_ctx.invoice.tax_percent) + " %", 1)
                        ])
                      ]),
                      _createElementVNode("h1", null, _toDisplayString(_ctx.numberWithDots(_ctx.invoice.total)) + " €", 1)
                    ], 64))
                  : (_openBlock(), _createBlock(_component_billing_change_subscription_sum_loader, { key: 2 })),
                _hoisted_16,
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_md_button, {
                    variant: "text",
                    grey: "",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.stepper.prev()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_18
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_md_button, {
                    variant: "filled",
                    onClick: _ctx.submitSubscription
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}